import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./ResponderFooter";

const SurveyResponderLayout = () => {
  const [footerAlign, setFooterAlign] = useState("end"); // default: in-progress survey layout

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <main className="flex-1 px-0.2 md:px-0.5 py-1.5">
        <Outlet context={{ setFooterAlign }} />
      </main>

      <Footer align={footerAlign} />
    </div>
  );
};

export default SurveyResponderLayout;